<template>
  <div style="margin-top: 50px;">
    <el-result :icon="icon" :title="title" :subTitle="subTitle">
      <template slot="extra">
        <el-button v-if="showPayButton" type="primary" @click="handleButtonClick()">点击此处确认支付结果</el-button>
      </template>
    </el-result>
  </div>
</template>

<script>
export default {
  data () {
    return {
      icon: 'info',
      title: '请确认支付结果',
      subTitle: '请点击下方按钮，确认您的支付结果。如果支付成功，请耐心等待教程作者联系您。如果支付失败，我们将不会联系您。',
      outTradeNo: '',
      payType: '',
      showPayButton: true, // 初始化为false，直到确认在前端才显示
      maxPollCount: 10,
      pollInterval: null,
      pollCount: 0
    }
  },
  mounted () {
    console.log('11111')
    this.startPolling()
  },
  beforeDestroy () {
    this.stopPolling()
  },
  methods: {
    handleButtonClick () {
      this.outTradeNo = localStorage.getItem('outTradeNo')
      this.payType = localStorage.getItem('payType')
      var bilibili = localStorage.getItem('bilibili')
      this.$axios.get('/api/pay/payment/getPaymentStatus/?out_trade_no=' + this.outTradeNo + '&payType=' + this.payType).then((response) => {
        if (response.data.code === 0) {
          if (bilibili === 1) {
            window.bilicm.mbase.report_data()
          }
          this.icon = 'success'
          this.title = '支付成功'
          this.subTitle = '您已成功购买AI测试开发教程试听，教程作者会亲自联系您，并与您沟通试听相关事项。请保持电话畅通，作者联系您的时间为早10点半~晚10点半。因试听人数较多，如果没及时联系您，请您理解。'
          this.showPayButton = false
          this.stopPolling()
        } else if (response.data.code === 1) {
          this.icon = 'error'
          this.title = '您未支付'
          this.subTitle = '您未支付，AI测试开发教程试听购买失败，您的信息我们并未存储，所以教程作者也不会联系您，祝您一切顺心！'
          this.showPayButton = false
        }
      })
    },
    startPolling () {
      this.pollInterval = setInterval(() => {
        this.pollCount++
        if (this.pollCount <= this.maxPollCount) {
          this.handleButtonClick()
        } else {
          this.stopPolling()
          this.icon = 'info'
          this.title = '请确认支付结果'
          this.subTitle = '系统检测您未支付。如果您想核实可点击下方按钮查询，未支付，我们将不会联系您。'
          this.showPayButton = true
        }
      }, 3000)
    },
    stopPolling () {
      clearInterval(this.pollInterval)
    }
  }
}
</script>

<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/payresult.vue